import { currentUserResource } from '@jira/router-resources__current-user/src/useCurrentUserResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
} from '@jira/router-resources__issue-navigator/src/issueNavigatorRelayResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { getIssueAppResources } from './getIssueAppResources.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getCommonGlobalResources = (): RouteResource<any>[] => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	...getNavigationResources(),
	...getIssueAppResources(),
	currentUserResource,
	...getDraftReplyPillsResource(),
	workspaceResource,
];
